import Joi from 'joi';
export var responseSchema = Joi.object({
    features: Joi.object({
        permitted: Joi.object()
            .pattern(Joi.string(), Joi.boolean())
            .allow(null),
        scope: Joi.string(),
        userID: Joi.number(),
    }).unknown(),
});
